/* tslint:disable */
/* eslint-disable */
/**
 * Změňte.to Admin API
 * Změňte.to Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurveyReassignUserRequestDTO
 */
export interface SurveyReassignUserRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof SurveyReassignUserRequestDTO
     */
    userId: number;
}

export function SurveyReassignUserRequestDTOFromJSON(json: any): SurveyReassignUserRequestDTO {
    return SurveyReassignUserRequestDTOFromJSONTyped(json, false);
}

export function SurveyReassignUserRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveyReassignUserRequestDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['userId'],
    };
}

export function SurveyReassignUserRequestDTOToJSON(value?: SurveyReassignUserRequestDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
    };
}

